import { GetStaticProps } from 'next'

import { convertToComponent } from '@ecm/data/Contentful'
import { Snippet } from '@ecm/data/Snippet'
import { runEff } from '@ecm/effect'
import PlainHeader from '@ecm/ui/component/block/PlainHeader'
import MainContainer from '@ecm/ui/element/MainContainer'
import DefaultLayout from '@ecm/ui/layout/Default'

type AcceptableUsePolicyPageProps = {
  policy: Snippet
}

const AcceptableUsePolicyPage = ({ policy }: AcceptableUsePolicyPageProps) => (
  <DefaultLayout
    hideFinalCta
    seoTitle="Acceptable Use Policy | Earth Class Mail"
    canonicalUrl="acceptable-use-policy"
  >
    <PlainHeader title="Acceptable Use Policy" />

    <MainContainer sx={{ paddingY: '4em' }}>
      {policy && convertToComponent(policy.content, 'p3')}
    </MainContainer>
  </DefaultLayout>
)

export default AcceptableUsePolicyPage

export const getStaticProps: GetStaticProps = async () => {
  const policy = await runEff(eff => eff.getSnippet('acceptable-use-policy'))

  return { props: { policy } }
}
